import { render, staticRenderFns } from "./AptItem.vue?vue&type=template&id=070ec506"
import script from "./AptItem.vue?vue&type=script&lang=js"
export * from "./AptItem.vue?vue&type=script&lang=js"
import style0 from "./AptItem.vue?vue&type=style&index=0&id=070ec506&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports